import React from 'react'
import { TableProps } from 'antd/lib/table'
import moment from 'moment'
import Tooltip from 'antd/lib/tooltip'

import { ColumnProps } from 'src/components/Ant/Table'
import { currencyMask } from 'src/components/Formik'
import { R10Data } from 'src/store/ducks/reports/types'
import { Table, Text } from 'src/components/Ant'
import { RequestTicketType } from 'src/types'

/**
 * common.ticket.type.ADVANCE
 * common.ticket.type.AIR
 * common.ticket.type.CHECK_IN
 * common.ticket.type.EXPENSE
 * common.ticket.type.HOTEL
 * common.ticket.type.OTHER
 * common.ticket.type.TRACK
 * common.ticket.type.VEHICLE
 */
const columns: ColumnProps<R10Data>[] = [
  {
    align: 'center',
    dataIndex: 'request_number',
    key: 'request_number',
    render: (request_number: string) => <Text>{request_number}</Text>,
    title: 'web.report.10.data.request_number',
    width: 70
  },
  {
    align: 'center',
    dataIndex: 'requested_on',
    key: 'requested_on',
    render: (requested_on: number) => (
      <Text>{moment.unix(requested_on).utc().format('DD/MM/YYYY')}</Text>
    ),
    title: 'web.report.10.data.requested_on'
  },
  {
    dataIndex: 'title',
    ellipsis: true,
    key: 'title',
    render: (title: string) => <Tooltip title={title}>{title}</Tooltip>,
    title: 'web.report.10.data.title'
  },
  {
    align: 'center',
    dataIndex: 'ticket_type',
    key: 'ticket_type',
    render: (ticket_type: RequestTicketType) => (
      <Text title={`common.ticket.type.${ticket_type.toLowerCase()}`} />
    ),
    title: 'web.report.10.data.ticket_type'
  },
  {
    align: 'right',
    dataIndex: 'amount',
    key: 'amount',
    render: (amount: number) => (
      <Text>
        {
          currencyMask({
            formatStr: true,
            precision: 2,
            value: amount
          }).maskedValue
        }
      </Text>
    ),
    title: 'web.report.10.data.amount'
  },
  {
    align: 'right',
    dataIndex: 'status',
    key: 'status',
    render: (ticket_status: string) => (
      <Text title={`common.status.unified.${ticket_status.toLowerCase()}`} />
    ),
    title: 'web.report.10.data.ticket_status'
  }
]

export default function TableDetail(props: TableProps<R10Data>) {
  return (
    <Table
      {...props}
      className="table-striped table-sm"
      columns={columns}
      pagination={false}
    />
  )
}
